// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

<template>
  <div class="user-menu-item">
    &nbsp;&nbsp;
      <FontAwesomeIcon :icon="'fa-globe'" />
        <a @click="setLang('en')">
            <span :style="getCurrentTranslation('en')"> English</span>
        </a> / 
        <a @click="setLang('es')">
            <span :style="getCurrentTranslation('es')"> Español</span>
        </a>
</div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/zh-cn'
import { loadLanguageAsync } from '@/locales'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

moment.locale('en')

export default {
  name: 'TranslationMenu',
  components: { FontAwesomeIcon },
  data () {
    return {
      language: 'en'
    }
  },
  mounted () {
    this.language = this.$localStorage.get('LOCALE') || 'en'
    this.setLocale(this.language)
  },
  methods: {
    getCurrentTranslation(langkey) {
        if (langkey == this.language) 
            return 'color: #40a9ff;'
        return 'color: #333;'
    },
    moment,
    setLang (lang) {
      console.log(' Requested lang: ', lang)
      if (!lang) {
        lang = 'en'
      }
      this.setLocale(lang)
    },
    setLocale (localeValue) {
      this.$i18n.locale = localeValue
      this.language = localeValue
      moment.locale(localeValue)
      this.$localStorage.set('LOCALE', localeValue)
      loadLanguageAsync(localeValue)
    }
  }
}
</script>

<style lang="less" scoped>
.translation-menu {
  font-size: 18px;
  line-height: 1;
}

</style>
